export const formatValue = value => {
  return value.toString().replace('.', ',');
};